module.exports = __webpack_public_path__ + "static/media/expressionTextOnly.91c660d4.png";